import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService} from '../account.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AccountUser} from '../../api/models/account-user';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {CurrentUser} from '../../api/models/current-user';
import {ModulesEnum} from '../../core/security/modules.enum';
import {BasicSoftphoneService as BasicSoftphoneApiService} from '../../api/services/basic-softphone.service';
import {BasicSoftPhoneSummaryModel} from '../../api/models/basic-soft-phone-summary-model';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { NgIf, NgFor } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ShowHideComponent } from '../../core/visual/show-hide/show-hide.component';
import { MatAnchor } from '@angular/material/button';
import { UnixTimePipe } from '../../core/pipes/unix-time.pipe';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';
import { YesNoPipe } from '../../core/pipes/yesno.pipe';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: true,
    imports: [
        MatCard,
        MatCardTitle,
        MatCardContent,
        NgIf,
        NgFor,
        RouterLink,
        FlexModule,
        MatIcon,
        MatTooltip,
        ShowHideComponent,
        MatAnchor,
        UnixTimePipe,
        PhoneNumberPipe,
        DateTimePipe,
        YesNoPipe,
    ],
})
export class UserComponent extends BaseComponent implements OnInit, OnDestroy {

  userModel: AccountUser = {id: 'new', approved: true, isLocked: true, emailConfirmed: false};
  editUserUrl: string;
  basicSoftPhoneSummary: BasicSoftPhoneSummaryModel = {};
  hasSoftPhoneModule: boolean;
  hasBasicSoftPhoneModule: boolean;
  hasProMessagingModule = false;
  editPhoneUrl = '/phone-numbers/phone-number';
  hasPhoneNumbersEditAccess = false;

  private paramsSubscription;
  private id: string;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              private softphoneApiService: BasicSoftphoneApiService,
              private accountService: AccountService) {
    super(route, headerService, titleService, authService);

    this.paramsSubscription = this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(this.id);
    });

    this.editUserUrl = './edit';
    this.headerService.showBackButton(true);

    this.editRoles = [RolesEnum.AccountUsers_Edit, RolesEnum.AccountUsers_Delete];
    this.deleteRoles = [RolesEnum.AccountUsers_Delete];

    this.hasPhoneNumbersEditAccess = this.authService.hasAccess([RolesEnum.PhoneNumbers_Edit, RolesEnum.PhoneNumbers_Delete])
  }

  onCurrentUserChanged(user: CurrentUser): void {
    if (user) {
      this.hasSoftPhoneModule = user.modules.indexOf(ModulesEnum.SoftPhoneModule) > -1;
      this.hasBasicSoftPhoneModule = user.modules.indexOf(ModulesEnum.BasicSoftPhoneModule) > -1;
    } else {
      this.hasSoftPhoneModule = false;
      this.hasBasicSoftPhoneModule = false;
    }

    this.hasProMessagingModule = this.authService.userHasPackage(ModulesEnum.ProMessagingModule);
  }

  async ngOnInit() {
    super.ngOnInit();

    this.userModel = await this.accountService.getUserById(this.id);

    if (this.userModel.extension) {
        await this.getSoftphoneSummary(this.userModel.extension);
    }

  }

  async getSoftphoneSummary(extension: string): Promise<void> {

    const summary = await this.softphoneApiService.basicSoftphoneExtensionSummary({
      extension: extension
    })
      .toPromise();

    this.basicSoftPhoneSummary = summary;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.paramsSubscription?.unsubscribe();
    this.headerService.showBackButton(false);
  }

}
